import React from "react";
import "./StorySection.css";
import logo from "assets/TNLogo.png";

export default function StorySection() {
  return (
    <div>
      <section className="story-section two-column">
        <div className="story-col left">
          <h2 className="story-heading">What You Will Learn</h2>
          <div className="story-content">
            <p>This is a step-by-step video course designed to take you from zero to viral without the guesswork.</p>
            <p>Using our proven 7-step system, you’ll learn how to create content that actually performs, even if you’ve never picked up a camera before.</p>
            <p><b>1. Study Your Niche on Social Media</b><br />Understand what works in your space by analysing trends, formats, and audience behaviour so you’re not just creating, you’re creating with purpose.</p>
            <p><b>2. Analyze the Competition</b><br />We’ll teach you how to reverse-engineer top creators by breaking down exactly what makes their videos successful and how you can do it better.</p>
            <p><b>3. Choose Your Video Style</b><br />From storytelling and educational explainers to lifestyle and behind-the-scenes, learn how to pick the right format for your brand and goals.</p>
            <p><b>4. Craft Irresistible Hooks</b><br />Discover our blueprint for scroll-stopping openers that grab attention in the first 3 seconds.</p>
            <p><b>5. Deliver Your Core Message Quickly</b><br />Master short-form storytelling techniques that keep viewers engaged and deliver value fast before they scroll away.</p>
            <p><b>6. Film Like a Pro Using Your Phone</b><br />We’ll show you the exact gear, framing, and lighting setups we use to make your content look premium without needing a production crew.</p>
            <p><b>7. Edit for Maximum Engagement</b><br />Learn how to cut faster, add captions, use music, sound design, and proven pacing tricks that drive watch time, shares, and saves.</p>
            <p>This is not just theory. It’s a practical, repeatable system used by viral creators and agencies to grow accounts, win clients, and build brands.</p>
          </div>
        </div>
        <div className="story-col right">
          <h2 className="story-heading">Who We Are</h2>
          <div className="story-content">
            <p>Tilted Needle is a global marketing agency of <b>50+</b> social-media experts.</p>
            <ul className="story-list">
              <li><b>£300,000,000+</b> in client revenue generated over the past year</li>
              <li><b>2,000,000,000+</b> views amassed across TikTok, Instagram, YouTube, and beyond</li>
              <li><b>10,000+</b> videos tested to decode exactly what makes content go viral</li>
              <li>Produced content with multiple billionaires around the world</li>
              <li><b>3</b> years of experience delivering viral social-media strategies</li>
              <li>Industry leaders in viral social-media content</li>
            </ul>
          </div>
        </div>
      </section>
      <div className="story-bottom-center professional-story-bottom">
        <p className="professional-story-main">
          No fluff. No filler. Just the exact same framework that delivers <b>100,000</b>-view launches and has driven <b>£300,000,000+</b> in revenue and <b>2,000,000,000+</b> views. Ready to replace trial and error with a battle-tested blueprint? This is your moment.
        </p>
        <div className="professional-story-signature">
          <span>Can't wait to see you go viral!<br/><em>— The Tilted Needle Team</em></span>
          <img src={logo} alt="Tilted Needle Logo" className="professional-story-logo" />
        </div>
      </div>
    </div>
  );
} 